<template>
  <div>
    <section>
  <SortableTable
    :is-editable="isEditable"
    :all-options="operatorListOptions"
    v-model="defaultLocalities"
    :columns="sortingTableColumns"
    :sortable="false"
    :delete-function="isDeletable"
    title="Výchozí lokalita pro operátory"
    name="default_localities"
    @input="onChange"
  />
    </section>
  </div>
</template>

<script>
import SortableTable from "../../../common/SortableTable.vue"
import message from "../../../mixins/message";

export default {
  name: "RelatedLocalities",
  mixins: [message],
  components: {SortableTable},
  props: {
    isEditable: Boolean,
    entity: Object,
    operatorOptions: Array,
  },
  created(LocalityService){
    this.localityService = LocalityService
    this.onLoad();
  },
  data(){
    return {
      oldDefaultLocalities: [],
      defaultLocalities: [],
    }
  },
  computed: {
    sortingTableColumns(){
      return [
        {text: this.$gettext('Operátor'), value: 'text'},
      ]
    },
    operatorListOptions(){
      let list = this.operatorOptions.filter(item => {
        return item.id != -1;
      });
      list.unshift({'id': null, 'text': this.$gettext('Globální')});

      return list;
    },
  },
  methods: {
    onLoad(){
      this.localityService.getDefaultLocalities(this.entity.id)
          .then((data) => {
            this.defaultLocalities = data.default_localities;
            this.oldDefaultLocalities = this.defaultLocalities.slice();
          })
    },
    isDeletable(value){
      return value != "null";
    },
    onChange(value){
      let deleted = this.oldDefaultLocalities.filter(item => !value.includes(item));
      let added = value.filter(item => !this.oldDefaultLocalities.includes(item));
      let params = null;
      if(added.length > 0){
        params = {'id_operator': added[0], 'state': true};
      }else if(deleted.length > 0){
        params = {'id_operator': deleted[0], 'state': false};
      }
      //this.oldDefaultLocalities = this.defaultLocalities.slice();

      this.localityService.setDefaultLocality(this.entity.id, params)
          .then(() => {
            this.onLoad();
            this.setSuccessMessage();
          });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/localities/locality/DefaultLocalities.vue